
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'

import VyHeaderXX from './VyHeaderXX'
import VySearchBarXX from './VySearchBarXX'
import Scroll from '&/basic/scroll' 
import VyCheckList from './VyCheckList'

export default {
name: 'VyCheckListPage',
components: {Popup, VyHeaderXX, VySearchBarXX, Scroll, VyCheckList},
directives: {TransferDom},
props: {
showMask: {type: Boolean, default: true}, // 是否显示遮罩
type: {type: String, required: true}, // 页面类型
isRadio: {type: Boolean, default: true}, // 是否单选
params: Object, // 参数列表
value: [String, Number, Array, Boolean],
showPopup: Boolean, // popup显隐状态
title: String, // 标题
searchPlaceholder: {type: String, default: ''}, // 搜索框预期值的提示信息
height: {type: String, default: '100%'}, // popup高度，推荐百分比
max: Number, // 多选最大限制
entityname: String, // 实体名
fieldName: String, // 字段名
},
data () {
return {
entity: '',
mapping: {}, // 多行显示映射表
options: [], // 选项集列表
list: [], // 列表
listAll: [],
currentPage: 0, // 当前页码
pageSize: 20, // 页容量
pullUpDirty: true, // 是否可继续pull
keyword: '', // 搜索关键字
tcode: 'get_lookup', // 发请求唯一编码
}
},
computed: {
isShow: {
get () {
return this.showPopup
},
set (newValue) {
this.$emit('update:showPopup', newValue)
},
},
},
watch: {
async showPopup (newValue) {
if(newValue === true && this.type === 'lookup') {
this.$loading.show()
await this.onPullingDown()
this.$loading.hide()
} else if(newValue === true && this.type === 'select') {
if(this.params && this.params.pickList) {
this.options = this.params.pickList
} else {
this.getSelectOptions(this.params)
}
} else {
this.list = []
this.options = []
this.keyword = ''
}
this.$emit('popup-change', newValue)
},
},
mounted () {
this.optionsReLoad() 
},
methods: {
async getSelectOptions (param) {
let params = {
tcode: 'getoptions',
entityname: this.entityname,
fieldname: this.fieldName,
}
params = {...params, ...param}
this.options = []
this.$loading.show()
await $appForm
.hdMetaData(params)
.then((res) => {
this.$loading.hide()
let resData = res.data || {}
if(resData.code === '10') {
let str = resData.result ? resData.result : ''

str = str.replace(/	/g, '')
let responseList = resData.result ? JSON.parse(str) : []
responseList.map(item => {
item.key = item.value
this.options.push(item)
})
} else {
console.error(resData)
this.$toast.show({
type: 'error',
content: resData.message || '请稍后重试', // 默认为空字符串，不传将不显示文案
position: 'middle', // 默认为middle，居中显示
})
}
})
.catch((err) => {
this.$loading.hide()
this.transFormErrorMsg(err)
})
},
async getAll (param) {
try {
let params = {
tcode: 'getlookups',


keyword: this.keyword,
pagecount: this.pageSize,
pagenumber: this.currentPage,
}
let extra = JSON.parse(JSON.stringify(this.params))
if(!this.isEmpty(this.keyword) && !this.isEmpty(extra.search) && !this.isEmpty(extra.keyword)) {
delete extra['search']
delete extra['keyword']
}
params = {...params, ...extra}
this.listAll = []
let res = {}
if(extra.tcode === 'new_asset_list' || extra.tcode === 'new_contract_list' || extra.tcode === 'new_contract_wglist' || extra.tcode === 'new_contract_yylist' || extra.tcode === 'new_hrperson_yylist') {
res = await $appForm.hdList(params)
} else {
res = await $appForm.hdMetaData(params)
}
let resData = res.data || {}
if(resData.code === '10') {
let str = resData.result ? resData.result : ''

str = str.replace(/	/g, '')
let responseList = resData.result ? JSON.parse(str) : []
if(extra.tcode === 'new_asset_list' || extra.tcode === 'new_contract_list' || extra.tcode === 'new_contract_wglist' || extra.tcode === 'new_contract_yylist' || extra.tcode === 'new_hrperson_yylist') {
if(extra.tcode === 'new_hrperson_yylist') {
responseList.map(item => {
item.key = item.new_name
item.value = item.new_name
item.label = item.new_name + '(' + item.new_person_number + ')'
this.listAll.push(item)
})
} else {
responseList.map(item => {
item.key = item.id
item.value = item.id
item.label = item.new_name
this.listAll.push(item)
})
}
} else {
responseList.map(item => {
item.key = item.value
this.listAll.push(item)
})
}
this.currentPage += 1
} else {
console.error(resData)
this.$toast.show({
type: 'error',
content: resData.message || '请稍后重试', // 默认为空字符串，不传将不显示文案
position: 'middle', // 默认为middle，居中显示
})
}
} catch (err) {
console.error(err)
}
},
async getFirstPage () {
try {
if(this.listAll.length <= this.pageSize) {
let dataList = this.listAll
.slice(0, this.listAll.length)
.map(this.listHandle)
this.list = dataList
this.pullUpDirty = false
this.$refs.scroll.forceUpdate(this.pullUpDirty)
} else {
let dataList = this.listAll
.slice(0, this.pageSize)
.map(this.listHandle)
this.list = dataList
this.pullUpDirty = true
this.$refs.scroll.forceUpdate(this.pullUpDirty)
}
} catch (err) {
console.error(err)
}
},
async getNextPage () {
try {
if(
this.listAll.length <=
this.currentPage * this.pageSize + this.pageSize
) {
let dataList = this.listAll
.slice(this.currentPage * this.pageSize, this.listAll.length)
.map(this.listHandle)
this.list = [...this.list, ...dataList]
this.pullUpDirty = false
this.$refs.scroll.forceUpdate(this.pullUpDirty)
} else {
let dataList = this.listAll
.slice(
this.currentPage * this.pageSize,
this.currentPage * this.pageSize + this.pageSize
)
.map(this.listHandle)
this.list = [...this.list, ...dataList]
this.pullUpDirty = true
this.$refs.scroll.forceUpdate(this.pullUpDirty)
}
this.currentPage += 1
} catch (err) {
console.error(err)
}
},
listHandle (item) {
let {
[this.mapping.key]: key,
[this.mapping.label]: label,
...res
} = item
return {key, label, ...res}
},
handleGoBack () {
this.$emit('update:showPopup', false)
},
async search (keyword) {
this.keyword = keyword
if(this.showPopup) {
this.$loading.show()
await this.onPullingDown()
this.$loading.hide()
}
},
async onPullingDown (paramsref = {}) {
if(this.params && this.params.pickList) {
var datalist = this.params.pickList

let extra = JSON.parse(JSON.stringify(this.params))
if(!this.isEmpty(this.keyword)) {
var search = !this.isEmpty(extra.search) ? extra.search : 'label' 
datalist = datalist.filter((item) => {
return item[search].includes(this.keyword)
})
}
this.list = datalist
this.$refs.scroll.forceUpdate(false) 
} else {
this.currentPage = 0
await this.getAll(paramsref)
await this.getFirstPage()
}
},
async onPullingUp () {
if(this.params && this.params.pickList) {
this.list = this.params.pickList
this.$refs.scroll.forceUpdate(false) 
} else {
await this.getNextPage()
}
},

checkValueChange (newValue) {
this.$emit('update:showPopup', false)
this.$emit('checkList-change', newValue, this.fieldName)
},
ensure () {
let {keys, labels} = this.$refs.checkList.getFullValue() 
if(this.isRadio === false) {
const findRegExp = /.*#.*/

keys = keys.map((item) =>
findRegExp.test(item) ? item : `${this.entity}#${item}`
)
}
this.$emit('update:showPopup', false)
this.$emit('checkList-change', {key: keys, label: labels})
},
reset () {
if(this.isRadio) {
this.$emit('update:showPopup', false)
this.$emit('checkList-change', {key: '', label: ''})
} else {
this.$emit('update:showPopup', false)
this.$emit('checkList-change', {key: [], label: []})
}
},

optionsReLoad () {
this.$on('optionsReLoad', (value) => {
this.options = value
})
},
},
}



// WEBPACK FOOTER //
// ./src/components/basic/VyCheckListPage.vue